import React, { useState, useRef, useEffect } from "react";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useHistory, Link } from "react-router-dom";
import isEmail from "validator/lib/isEmail";
// import Alert from '@material-ui/lab/Alert';
import CircularProgress from "@material-ui/core/CircularProgress";
import { useSnackbar } from "notistack";
import { LockOutlined, PeopleOutline } from "@material-ui/icons";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";

import { useData } from "../../../components/firebase/DataProvider";
import {
  firefunctions,
  FieldValue,
  auth,
} from "../../../components/firebase/FirebaseProvider";
import ImageGelombang from "../../../assets/images/login-gelombang.svg";
import Navbar from "../../../components/molecules/navbarLogReg";
import ImageFamily from "../../../assets/images/family.svg";
import useStyles from "./style";
import { Typography } from "@material-ui/core";

function getAkunType(referral) {
  if (referral.ref_agen) {
    return "reseller";
  } else if (referral.ref_distributor) {
    return "agen";
  } else if (referral.ref_mentorbisnis) {
    return "distributor";
  }
}

function getUplineType(uplines) {
  if (uplines.agen) {
    return { nama: uplines.agen, level: "Agen" };
  } else if (uplines.distributor) {
    return { nama: uplines.distributor, level: "Distributor" };
  } else if (uplines.mentorbisnis) {
    return { nama: uplines.mentorbisnis, level: "Mentorbisnis" };
  }
}

export default function Form() {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("951"));
  const matches1 = useMediaQuery(theme.breakpoints.up("lg"));
  const matches2 = useMediaQuery(theme.breakpoints.up("tablet"));
  const [year] = useState(new Date().getFullYear());
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const { profilRef, phone, profil, webstore, sourceCategories } = useData();
  const [errors, setErrors] = useState({});
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [showPassAgain, setShowPassAgain] = useState(false);
  const [showCheck, setshowCheck] = useState(false);
  const [mode, setMode] = useState(1);
  // const [showKonfirmasi, setShowKonfirmasi] = useState(false);
  const dataRefferal = useRef({});
  const dataUpline = useRef({});

  const newData = [];
  sourceCategories?.registration.map((data) => {
    newData.push(data);
  });
  newData.push("Lainnya");

  const handleShowPass = () => {
    if (showPass) {
      setShowPass(false);
    } else {
      setShowPass(true);
    }
  };

  const handleShowPassAgain = () => {
    if (showPassAgain) {
      setShowPassAgain(false);
    } else {
      setShowPassAgain(true);
    }
  };

  const handleCheck = () => {
    if (showCheck) {
      setshowCheck(false);
    } else {
      setshowCheck(true);
    }
  };

  const handleChange = (name) => (values) => {
    // console.log('ini data', values.target.value)
    setForm({ ...form, [name]: values.target.value });
    setErrors({ ...errors, [name]: "" });
  };

  const validate = async () => {
    let newErrors = {};
    if (!form.nama) {
      newErrors.nama = "Nama wajib Diisi";
    }
    if (form.email && !isEmail(form.email)) {
      newErrors.email = "Email tidak valid";
    }

    if (!form.kode_referral) {
      newErrors.kode_referral = "Kode referral wajib diisi";
    } else {
      const validateRefferal = firefunctions.httpsCallable("validateReferral");
      const referral = await validateRefferal({
        kode: form.kode_referral,
      });
      const { valid, message, upline, ...restRef } = referral.data;
      if (!valid) {
        newErrors.kode_referral = message;
      } else {
        dataRefferal.current = restRef;
        dataUpline.current = getUplineType(upline);
      }
    }
    // console.log("ini kodereffreal", referral?.data);

    if (!form.password) {
      newErrors.password = "Password wajib diisi";
    } else if (form.password.length < 8) {
      newErrors.password = "Password minimal 8 karakter";
    }
    if (!form.passwordAgain) {
      newErrors.passwordAgain = "Ulangi Password wajib diisi";
    } else if (form.password !== form.passwordAgain) {
      newErrors.passwordAgain = "Ulangi Password tidak sama dengan password";
    }
    // if (!showCheck) {
    //   newErrors.showCheck = "Wajib di centang";
    // }
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    const findErrors = await validate();
    console.log("asasa", findErrors);

    if (Object.values(findErrors).some((message) => message !== "")) {
      setErrors(findErrors);
      console.log("asasa", errors);
      setLoading(false);
    } else {
      try {
        await profilRef.set(
          {
            web: true,
          },
          { merge: true }
        );
        setLoading(false);
        setMode(2);
      } catch (e) {
        setLoading(false);
        enqueueSnackbar("Terjadi Kesalahan, Silahkan Coba Lagi Nanti", {
          variant: "warning",
        });
      }
    }
  };

  const handleSubmitOld = async (e) => {
    e.preventDefault();

    setLoading2(true);
    const findErrors = await validate();
    console.log("asasa", findErrors);

    if (Object.values(findErrors).some((message) => message !== "")) {
      setErrors(findErrors);
      console.log("asasa", errors);
      setLoading(false);
    } else {
      try {
        const { password, passwordAgain, ...restForm } = form;

        // step one set password
        const setPassword = firefunctions.httpsCallable("setPassword");
        await setPassword({
          password: password,
          ulangi_password: passwordAgain,
        });

        // step two get type akun untuk alokasi pembayaran ke midtrans
        const tipe_akun = getAkunType(dataRefferal.current);

        await profilRef.set(
          {
            ...restForm,
            tipe_akun,
            ...dataRefferal.current,
            created_at: FieldValue.serverTimestamp(),
            updated_at: FieldValue.serverTimestamp(),
          },
          { merge: true }
        );
        history.push(`/register/pembayaran`);
        enqueueSnackbar("Profil Berhasil Dilengkapi", {
          variant: "success",
        });
        setLoading(false);
      } catch (e) {
        setLoading2(false);
        enqueueSnackbar("Terjadi Kesalahan, Silahkan Coba Lagi Nanti", {
          variant: "warning",
        });
      }
    }
  };

  const handleSignOut = async () => {
    await auth.signOut();
  };

  useEffect(() => {
    if (profil?.nama || webstore?.domain) {
      history.push(`/`);
    }
  }, []);

  return (
    <div style={{ background: "white" }}>
      <div className={classes.header}>
        <Navbar />
        <div>
          <div>
            <img
              src={ImageGelombang}
              alt="Gelombang"
              className={classes.gelombang}
            />
          </div>
          {matches ? (
            <div
              style={{
                margin: "5%",
                marginLeft: "10%",
              }}
            >
              <img
                src={ImageFamily}
                alt="Family"
                style={{ width: "30%", position: "absolute" }}
              />
            </div>
          ) : null}
          <div>
            <div className={classes.content}>
              {mode === 1 ? (
                <>
                  <div className={classes.boxContent}>
                    <div className={classes.textContent3}>
                      <h4 className={classes.textContent3H4}>
                        Lengkapi Form dibawah ini
                      </h4>
                    </div>
                    <div className={classes.garisContent} />
                    <form noValidate autoComplete="off" onSubmit={handleSubmit}>
                      <FormControl variant="outlined" style={{ width: "90%" }}>
                        <InputLabel
                          htmlFor="outlined-adornment-amount"
                          style={{
                            fontWeight: "bold",
                            color: "#000000a8",
                          }}
                          slot="true"
                        >
                          Nama
                        </InputLabel>
                        <OutlinedInput
                          className={matches2 ? classes.inputTest : null}
                          // id="outlined-adornment-amount"
                          label="Nama"
                          placeholder="Teddi rahman"
                          error={errors.nama ? true : false}
                          value={form.nama}
                          onChange={handleChange("nama")}
                          startAdornment={
                            <InputAdornment position="start">
                              <PersonOutlineIcon color="action" />
                            </InputAdornment>
                          }
                          labelWidth={0}
                        />
                        {errors.nama ? (
                          <div style={{ display: "flex", margin: 2 }}>
                            <span style={{ fontSize: 9, color: "red" }}>
                              {errors.nama}
                            </span>
                          </div>
                        ) : null}
                      </FormControl>
                      <FormControl
                        variant="outlined"
                        style={{
                          width: "90%",
                          marginTop: errors.nama ? 10 : 15,
                        }}
                      >
                        <InputLabel
                          htmlFor="outlined-adornment-amount"
                          style={{ fontWeight: "bold", color: "#000000a8" }}
                          slot="true"
                        >
                          Email Opsional
                        </InputLabel>
                        <OutlinedInput
                          className={matches2 ? classes.inputTest : null}
                          // id="outlined-adornment-amount"
                          label="Email Opsional"
                          placeholder="wadidaw_club@gmail.com"
                          error={errors.email ? true : false}
                          value={form.email}
                          onChange={handleChange("email")}
                          startAdornment={
                            <InputAdornment position="start">
                              <MailOutlineIcon color="action" />
                            </InputAdornment>
                          }
                          labelWidth={0}
                        />
                        {errors.email ? (
                          <div style={{ display: "flex", margin: 2 }}>
                            <span style={{ fontSize: 9, color: "red" }}>
                              {errors.email}
                            </span>
                          </div>
                        ) : null}
                      </FormControl>
                      <FormControl
                        variant="outlined"
                        style={{
                          width: "90%",
                          marginTop: errors.nama ? 10 : 15,
                        }}
                      >
                        <InputLabel
                          htmlFor="outlined-adornment-amount"
                          style={{ fontWeight: "bold", color: "#000000a8" }}
                          slot="true"
                        >
                          Password
                        </InputLabel>
                        <OutlinedInput
                          className={matches2 ? classes.inputTest : null}
                          // id="outlined-adornment-amount"
                          label="Password"
                          placeholder="Password"
                          error={errors.password ? true : false}
                          value={form.password}
                          type={showPass === true ? "text" : "password"}
                          onChange={handleChange("password")}
                          startAdornment={
                            <InputAdornment position="start">
                              <LockOutlined color="action" />
                            </InputAdornment>
                          }
                          labelWidth={0}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleShowPass}
                                edge="end"
                              >
                                {showPass ? <Visibility /> : <VisibilityOff />}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                        {errors.password ? (
                          <div style={{ display: "flex", margin: 2 }}>
                            <span style={{ fontSize: 9, color: "red" }}>
                              {errors.password}
                            </span>
                          </div>
                        ) : null}
                      </FormControl>
                      <FormControl
                        variant="outlined"
                        style={{
                          width: "90%",
                          marginTop: errors.nama ? 10 : 15,
                        }}
                      >
                        <InputLabel
                          htmlFor="outlined-adornment-amount"
                          style={{ fontWeight: "bold", color: "#000000a8" }}
                          slot="true"
                        >
                          Konfirmasi Password
                        </InputLabel>
                        <OutlinedInput
                          className={matches2 ? classes.inputTest : null}
                          // id="outlined-adornment-amount"
                          label="Konfirmasi Password"
                          placeholder="Konfirmasi Password"
                          error={errors.passwordAgain ? true : false}
                          value={form.passwordAgain}
                          type={showPassAgain ? "text" : "password"}
                          onChange={handleChange("passwordAgain")}
                          startAdornment={
                            <InputAdornment position="start">
                              <LockOutlined color="action" />
                            </InputAdornment>
                          }
                          labelWidth={0}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleShowPassAgain}
                                edge="end"
                              >
                                {showPassAgain ? (
                                  <Visibility />
                                ) : (
                                  <VisibilityOff />
                                )}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                        {errors.passwordAgain ? (
                          <div style={{ display: "flex", margin: 2 }}>
                            <span style={{ fontSize: 9, color: "red" }}>
                              {errors.passwordAgain}
                            </span>
                          </div>
                        ) : null}
                      </FormControl>
                      <div
                        style={{
                          paddingLeft: 30,
                          paddingRight: 30,
                          textAlign: "initial",
                        }}
                      >
                        <text style={{ fontSize: 10 }}>
                          Masukan kode referral yang kamu punya atau tanya ke cs
                        </text>
                      </div>
                      <FormControl
                        variant="outlined"
                        style={{
                          width: "90%",
                          marginTop: errors.nama ? 10 : 15,
                        }}
                      >
                        <InputLabel
                          htmlFor="outlined-adornment-amount"
                          style={{ fontWeight: "bold", color: "#000000a8" }}
                          slot="true"
                        >
                          Kode Referral
                        </InputLabel>
                        <OutlinedInput
                          className={matches2 ? classes.inputTest : null}
                          // id="outlined-adornment-amount"
                          label="Kode Referral"
                          placeholder="Kode Referral"
                          error={errors.kode_referral ? true : false}
                          value={form.kode_referral}
                          onChange={handleChange("kode_referral")}
                          startAdornment={
                            <InputAdornment position="start">
                              <PeopleOutline color="action" />
                            </InputAdornment>
                          }
                          labelWidth={0}
                        />
                        {errors.kode_referral ? (
                          <div style={{ display: "flex", margin: 2 }}>
                            <span style={{ fontSize: 9, color: "red" }}>
                              {errors.kode_referral}
                            </span>
                          </div>
                        ) : null}
                      </FormControl>
                      <div
                        style={{
                          paddingLeft: 30,
                          paddingRight: 30,
                          marginTop: 10,
                          marginBottom: 10,
                          textAlign: "end",
                        }}
                      >
                        <text style={{ fontSize: 10 }}>
                          Belum punya kode referral?
                          <Link
                            className={classes.link}
                            onClick={() =>
                              window.open(
                                "https://api.whatsapp.com/send/?phone=6281268000433&text=Halo, saya ingin bergabung menjadi reseller Tokorame, tapi tidak punya kode referral&app_absent=0"
                              )
                            }
                          >
                            Tanya CS
                          </Link>
                        </text>
                      </div>
                      <Button
                        variant="contained"
                        color="primary"
                        style={{ marginBottom: 10, width: "90%" }}
                        // onClick={handleSubmit}
                        type="submit"
                        disabled={loading ? true : false}
                      >
                        {loading === true ? (
                          <CircularProgress
                            size={24}
                            style={{ color: "#5675D3" }}
                          />
                        ) : (
                          "Lanjutkan"
                        )}
                      </Button>
                      <Button
                        variant="outlined"
                        color="primary"
                        style={{ marginBottom: 10, width: "90%" }}
                        onClick={handleSignOut}
                      >
                        Keluar
                      </Button>
                    </form>
                  </div>
                </>
              ) : mode === 2 ? (
                <>
                  <div className={classes.boxContent}>
                    <div style={{ margin: "20px" }}>
                      <div>
                        <Typography
                          align="left"
                          style={{
                            fontSize: 16,
                            fontWeight: "bold",
                            marginBottom: 10,
                          }}
                        >
                          Hay {form.nama} Dari Mana Kamu Mengenal Tokorame ?
                        </Typography>
                      </div>
                      {/* <div className={classes.garisContent} /> */}
                      <div>
                        {newData?.map((item) => {
                          const selected = form?.source === item;
                          return (
                            <Button
                              fullWidth
                              variant="contained"
                              // color="primary"
                              size="small"
                              style={{
                                marginTop: 10,
                                borderRadius: 50,
                                textTransform: "capitalize",
                                color: selected ? "white" : "black",
                                backgroundColor: selected
                                  ? "#5675D3"
                                  : "#e9f3fc",
                                  boxShadow:"none",
                                  justifyContent:"flex-start"
                              }}
                              onClick={() => {
                                setForm((form) => ({ ...form, source: item }));
                                setMode(3);
                              }}
                            >
                              {item}
                            </Button>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div
                    className={classes.boxContent}
                    style={{ marginTop: "5%" }}
                  >
                    <div>
                      <h1>KONFIRMASI</h1>
                      <div className={classes.textHeaderKonfirmasi}>
                        <h3 className={classes.konfirmasih3}>
                          Anda akan terdaftar sebagai seller Tokorame dengan
                          data sebagai berikut :
                        </h3>
                      </div>
                      <div className={classes.textBox}>
                        <div className={classes.textBoxBody}>
                          <div style={{ display: "flex" }}>
                            <p
                              className={classes.textBoxRight}
                              style={{ fontWeight: "bold" }}
                            >
                              {dataUpline.current?.level}
                            </p>
                            <p className={classes.textBoxLeft}>
                              {":  " + dataUpline.current?.nama}
                            </p>
                          </div>
                          <div
                            style={{
                              textAlign: "left",
                              backgroundColor: "#eeececa3",
                              marginBottom: "8%",
                            }}
                          >
                            <div style={{ display: "flex", height: "30px" }}>
                              <p className={classes.textBoxRight}>Nama</p>
                              <p className={classes.textBoxLeft}>
                                {":  " + form?.nama}
                              </p>
                            </div>
                            <div style={{ display: "flex", height: "30px" }}>
                              <p className={classes.textBoxRight}>No Wa</p>
                              <p className={classes.textBoxLeft}>
                                {":  " + phone?.id}
                              </p>
                            </div>
                            <div style={{ display: "flex" }}>
                              <p className={classes.textBoxRight}>Level</p>
                              <p className={classes.textBoxLeft}>
                                {":  " + getAkunType(dataRefferal.current)}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <Checkbox
                        checked={showCheck}
                        onClick={handleCheck}
                        name="checkedB"
                        color="primary"
                        size="small"
                        // onError={errors.checked ? true : false}
                      />
                      <text style={{ fontSize: 10 }}>
                        I agree on Tokorame Terms and Conditions{" "}
                      </text>
                    </div>
                    <Button
                      variant="contained"
                      color="primary"
                      style={{ marginBottom: 10, width: "90%" }}
                      onClick={handleSubmitOld}
                      type="submit"
                      disabled={!showCheck || loading2 ? true : false}
                    >
                      {loading2 === true ? (
                        <CircularProgress
                          size={24}
                          style={{ color: "#5675D3" }}
                        />
                      ) : (
                        "Lanjutkan"
                      )}
                    </Button>
                    <Button
                      color="primary"
                      variant="outlined"
                      style={{ marginBottom: 10, width: "90%" }}
                      onClick={() => setMode(1)}
                      type="submit"
                      disabled={loading2 ? true : false}
                    >
                      Batal
                    </Button>
                  </div>
                </>
              )}
            </div>
            <div className={classes.textCopyright}>
              {matches1 ? (
                <h5 className={classes.textCopyrightH5}>
                  Copyright © TokoRame {year}
                </h5>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
